import { render, staticRenderFns } from "./bubble2.md?vue&type=template&id=15c0d9b1&"
import script from "./bubble2.md?vue&type=script&lang=js&"
export * from "./bubble2.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15c0d9b1')) {
      api.createRecord('15c0d9b1', component.options)
    } else {
      api.reload('15c0d9b1', component.options)
    }
    module.hot.accept("./bubble2.md?vue&type=template&id=15c0d9b1&", function () {
      api.rerender('15c0d9b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/demo/scatter/bubble2.md"
export default component.exports